import { Router } from '@angular/router';
import { AuthService } from '../providers/auth/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "../providers/auth/auth.service";
import * as i2 from "@angular/router";
var DashboardRedirectGuard = /** @class */ (function () {
    function DashboardRedirectGuard(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    DashboardRedirectGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        if (state.url.includes('/defect/')) {
            return true;
        }
        return this.authService.checkToken().then(function (value) {
            if (!_this.authService.authenticationState.getValue()) {
                return true;
            }
            var user = _this.authService.user;
            if (!user) {
                user = _this.authService.getUserProfile();
                if (!user) {
                    return true;
                }
            }
            if (!user || !user.extra_vars || !user.extra_vars.permissions) {
                return true;
            }
            var hasDepotKioskPermission = user.extra_vars.permissions.some(function (perm) { return perm.PermissionName === 'Defect Depot Kiosk'; });
            if (hasDepotKioskPermission) {
                _this.router.navigateByUrl('/dashboard-depot');
                return false;
            }
            return true;
        }).catch(function (error) {
            console.log('DashboardRedirectGuard - error:', error);
            return true;
        });
    };
    DashboardRedirectGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardRedirectGuard_Factory() { return new DashboardRedirectGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router)); }, token: DashboardRedirectGuard, providedIn: "root" });
    return DashboardRedirectGuard;
}());
export { DashboardRedirectGuard };
